export default __webpack_public_path__ + "static/logo-android-f6d4cf1b9c36a10ad96eb88dd27b5336.svg";